<template>
  <v-container
    class="direct-signings-view-container"
    fluid
  >
    <h1>Zeichnungbescheinigung Einzelinvestment</h1>
    <direct-signings-table
      :signings="directSignings"
      :loading="loading"
    />
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { DirectSigningsTable } from '@/components/ire';

export default {
  name: 'DirectSignings',
  components: {
    'direct-signings-table': DirectSigningsTable,
  },
  computed: {
    ...mapState({
      loading: state => state.financialProductsStore.loading,
      directSignings: state => state.directSigningsStore.directSignings,
    }),
  },
  mounted() {
    this.getDirectSignings();
  },
  methods: {
    ...mapActions(['getDirectSignings']),
  },
};
</script>


<style lang="scss" scoped>
.direct-signings-view-container{
  max-width: 1500px;
}
</style>



// WEBPACK FOOTER //
// src/views/ire/DirectSignings.vue